// Tỉnh thành
export default {
    HaNoi: 1, // 'Hà Nội',
    HoChiMinh: 2, // 'Hồ Chí Minh',
    DaNang: 3, // 'Đà Nẵng',
    CanTho: 4, // 'Cần Thơ',
  };
  